import React from 'react';
import db from '../data/db.json';
import './Products.css';

const Products = () => {
  const { title, categories, process } = db.products;

  return (
    <div className="products">
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">{title}</h1>
        </div>
      </section>

      <section className="categories-section">
        <div className="container">
          <div className="categories-grid">
            {categories.map((category, index) => (
              <div key={index} className="category-card">
                <div className="category-icon">{category.image}</div>
                <h3 className="category-name">{category.name}</h3>
                <p className="category-description">{category.description}</p>
                <ul className="category-items">
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="process-section">
        <div className="container">
          <h2 className="section-title">Our Process</h2>
          <div className="process-timeline">
            {process.map((step, index) => (
              <div key={index} className="process-step">
                <div className="process-number">{step.step}</div>
                <div className="process-content">
                  <h3 className="process-title">{step.title}</h3>
                  <p className="process-description">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;

